/** Installed hardware counts are independent of editable estimate line quantities. */
export type SolarEquipmentRole = 'PV' | 'STORAGE' | 'PV_AND_STORAGE';

export type InstalledSolarEquipment<T> = {
  appliance: T;
  quantity: number;
  role: SolarEquipmentRole;
  warnings?: string[];
  inverterInstanceId?: string;
  equipmentSelectionId?: string;
};

/** Legacy included battery selections represent one unit; excluded storage is zero. */
export const solarBatteryQuantity = (selection: {
  includeBattery?: boolean | null;
  batteryQuantity?: number | null;
}): number => (selection.includeBattery ? (selection.batteryQuantity ?? 1) : 0);

/** Capacity is a per-unit energy rating, not evidence of parallel power limits. */
export const installedBatteryCapacityKwh = (
  usableCapacityKwh: number | null | undefined,
  quantity: number
): number | null =>
  usableCapacityKwh != null &&
  Number.isFinite(usableCapacityKwh) &&
  usableCapacityKwh > 0 &&
  Number.isSafeInteger(quantity) &&
  quantity > 0
    ? usableCapacityKwh * quantity
    : null;
